/* Nola — pop-up de bienvenida BIENVENIDA10 (R95).
   sessionStorage: nbOfferStart (hora de entrada en la tienda) · nolaModalSeen (ya se abrió solo) ·
   nolaOfferClosed (lo cerró: se muestra la pestaña) · nolaOfferDismissed (ocultó la pestaña).
   Sin tracking: no llama a fbq, WeTrack ni analytics. */
(function () {
  var tab = document.querySelector('[data-nb-offerbar]');
  var modal = document.getElementById('nb-offermodal');
  if (!tab || !modal || !modal.showModal) return;

  var DELAY = 12000;
  var S = {
    get: function (k) { try { return sessionStorage.getItem(k); } catch (e) { return null; } },
    set: function (k, v) { try { sessionStorage.setItem(k, v || '1'); } catch (e) {} }
  };

  // Hora de entrada: se fija en la primera página de la sesión y no se reinicia al navegar.
  var now = Date.now();
  var start = parseInt(S.get('nbOfferStart') || '', 10);
  if (!start || start > now) { start = now; S.set('nbOfferStart', String(now)); }

  // --- pestaña de recuperación: tras cerrar el pop-up, cede ante el sticky ATC ---
  var atc = document.querySelector('.nb-sticky-atc');
  var atcVisible = function () { return atc && !atc.hasAttribute('hidden') && getComputedStyle(atc).display !== 'none'; };
  // Banner de cookies de Shopify: primero que la clienta decida; ni pop-up ni pestaña encima.
  function cookieBannerOpen() {
    var c = document.getElementById('shopify-pc__banner');
    return !!(c && c.getClientRects().length && getComputedStyle(c).visibility !== 'hidden');
  }
  var cookieWatch = null;
  function refreshTab() {
    var cookie = cookieBannerOpen();
    if (cookie && !cookieWatch) cookieWatch = setInterval(refreshTab, 1500);
    if (!cookie && cookieWatch) { clearInterval(cookieWatch); cookieWatch = null; }
    var show = S.get('nolaOfferClosed') === '1' && S.get('nolaOfferDismissed') !== '1' && !modal.open && !atcVisible() && !cookie;
    tab.hidden = !show;
    document.body.classList.toggle('nb-offerbar-on', show);
  }
  if (atc) new MutationObserver(refreshTab).observe(atc, { attributes: true, attributeFilter: ['hidden', 'style', 'class'] });

  var lastFocus = null;
  function openModal() {
    if (modal.open) return;
    lastFocus = document.activeElement;
    modal.showModal();
    refreshTab();
    var cta = modal.querySelector('[data-nb-offer-copy]');
    if (cta) cta.focus();
  }
  function closeModal() { if (modal.open) modal.close(); }
  modal.addEventListener('close', function () {
    S.set('nolaOfferClosed');
    refreshTab();
    var target = tab.hidden ? lastFocus : tab.querySelector('[data-nb-offer-open]');
    if (target && target.focus && document.contains(target)) target.focus();
  });

  // --- apertura automática: 12 s desde la entrada, una vez por sesión, nunca sobre otro modal ---
  function anotherModalOpen() {
    var dlgs = document.querySelectorAll('dialog[open]');
    for (var i = 0; i < dlgs.length; i++) { if (dlgs[i] !== modal) return true; }
    if (document.querySelector('cart-drawer.active, cart-drawer[open], .menu-drawer[open], header-drawer details[open], details-modal details[open], quick-add-modal[open], quick-add-modal.active')) return true;
    var b = document.body.classList;
    if (cookieBannerOpen()) return true;
    if (b.contains('overflow-hidden') || b.contains('overflow-hidden-tablet') || b.contains('overflow-hidden-mobile') || b.contains('overflow-hidden-desktop')) return true;
    // compra en curso o escribiendo en un campo
    var a = document.activeElement;
    if (a && a.closest && (a.closest('form[action*="/cart"]') || /^(INPUT|TEXTAREA|SELECT)$/.test(a.tagName))) return true;
    return false;
  }
  function attempt() {
    if (S.get('nolaModalSeen') === '1' || modal.open) return;
    if (document.hidden || anotherModalOpen()) { setTimeout(attempt, 1500); return; }
    S.set('nolaModalSeen');
    openModal();
  }
  // R96: vuelta del formulario de suscripción (solo si nb_email_capture está activo): reabre con el aviso.
  var posted = modal.querySelector('[data-nb-offer-posted]');
  var clubForm = modal.querySelector('.nbw__form');
  if (clubForm) clubForm.addEventListener('submit', function () { try { sessionStorage.setItem('nbClubScrollPosition', String(window.scrollY)); } catch (e) {} });
  if (posted || (clubForm && clubForm.querySelector('.nbw__err'))) {
    try { history.scrollRestoration = 'manual'; } catch (e) {}
    var y = null;
    try { y = sessionStorage.getItem('nbClubScrollPosition'); sessionStorage.removeItem('nbClubScrollPosition'); } catch (e) {}
    if (location.hash) { try { history.replaceState(null, '', location.pathname + location.search.replace(/([?&])customer_posted=true&?/, '$1').replace(/[?&]$/, '')); } catch (e) {} }
    if (y !== null) { window.scrollTo(0, parseInt(y, 10) || 0); requestAnimationFrame(function () { window.scrollTo(0, parseInt(y, 10) || 0); }); }
    S.set('nolaModalSeen');
    setTimeout(openModal, 300);
  } else if (S.get('nolaModalSeen') !== '1') setTimeout(attempt, Math.max(0, start + DELAY - Date.now()));
  refreshTab();
  document.addEventListener('visitorConsentCollected', function () { setTimeout(refreshTab, 300); });

  // --- eventos ---
  modal.querySelectorAll('[data-nb-offer-modal-close]').forEach(function (b) { b.addEventListener('click', closeModal); });
  modal.addEventListener('click', function (e) { if (e.target === modal) closeModal(); });
  tab.querySelector('[data-nb-offer-open]').addEventListener('click', openModal);
  tab.querySelector('[data-nb-offer-close]').addEventListener('click', function () { S.set('nolaOfferDismissed'); refreshTab(); });

  var copy = modal.querySelector('[data-nb-offer-copy]');
  var codeEl = modal.querySelector('[data-nb-offer-code]');
  var status = modal.querySelector('[data-nb-offer-status]');
  var label = copy ? copy.textContent : '';
  function fallbackCopy(text) {
    var ta = document.createElement('textarea');
    ta.value = text; ta.setAttribute('readonly', ''); ta.style.position = 'fixed'; ta.style.opacity = '0';
    modal.appendChild(ta); ta.select();
    var ok = false;
    try { ok = document.execCommand('copy'); } catch (e) {}
    modal.removeChild(ta);
    return ok;
  }
  function done(ok, text) {
    copy.textContent = ok ? (copy.getAttribute('data-copied-label') || '¡Código copiado!') : label;
    if (status) status.textContent = ok ? 'Código ' + text + ' copiado. Pégalo al finalizar la compra.' : 'No se ha podido copiar. Tu código es ' + text + '.';
    copy.focus();
    setTimeout(function () { copy.textContent = label; }, 2200);
  }
  if (copy && codeEl) copy.addEventListener('click', function () {
    var text = codeEl.textContent.trim();
    if (navigator.clipboard && window.isSecureContext) {
      navigator.clipboard.writeText(text).then(function () { done(true, text); }, function () { done(fallbackCopy(text), text); });
    } else {
      done(fallbackCopy(text), text);
    }
  });
})();
